export default __webpack_public_path__ + "static/media/mary_s.b86bf6ea.jpg";